import { render, staticRenderFns } from "./MiFormacionComponent.vue?vue&type=template&id=3055717e&"
import script from "./MiFormacionComponent.vue?vue&type=script&lang=js&"
export * from "./MiFormacionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports